/* Human-readable labels for service-type enums used in courier benchmarking.
   Benchmarking is grouped by serviceTypePrimary (see redux/courierPerformance);
   this maps the raw enum (e.g. FWD_SURFACE_REG) to a readable label. Unknown
   enums fall back to a prettified version of the raw value. */
const LABELS = {
  FWD_SURFACE_REG: 'Surface',
  FWD_SURFACE_LARGE: 'Surface (Large)',
  FWD_AIR_REG: 'Air',
  SDD_FWD_REG: 'Same-Day (SDD)',
  Intercity_NDD_REG: 'Intercity NDD',
  SC_NDD_REG: 'Same-City NDD',
  HV_FWD_Large: 'High Value (Large)',
  HV_FWD_REG: 'High Value',
  REV_REG_QC: 'Reverse (QC)',
  REV_REG_NOQC: 'Reverse (No QC)',
  REV_REG: 'Reverse',
  UNKNOWN: 'Unknown',
}

export function serviceTypeLabel(st) {
  if (!st) return 'Unknown'
  if (LABELS[st]) return LABELS[st]
  return String(st)
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase())
}
